import './Comments.css';

import { IonGrid, IonRow } from '@ionic/react';
import React from 'react';

import Comment from '../../components/comment/Comment';
import ContentSpinner from '../../components/loading/ContentSpinner';
import { Empty } from '../../layouts/errors/Empty';
import { chatboxOutline } from 'ionicons/icons';

interface Props {
    data: any,
    loadMore?: any
}

const Comments: React.FC<Props> = (props) => {
    return <ContentSpinner loadData={props.loadMore}>
        <IonRow>
            <Empty text="نظری ثبت نشده است!" icon={chatboxOutline} length={props.data?.length}>
                {props.data?.map((item: any) => {
                    return <Comment title={item['name']} date={item['date']} text={item['comment']} reply={item['reply']} isBuyer={item['is_buyer']} />
                })}
            </Empty>
        </IonRow>
    </ContentSpinner>
}

export default Comments